
/* ============================================================================
   PUENTE · el motor de escena dentro del sitio
   ----------------------------------------------------------------------------
   El sitio pinta cada imagen de producto como un <div class="cat-img n-xxx">
   con un fondo CSS. Este puente los localiza, averigua de que fragancia son y
   les monta encima la escena del motor.

   No toca una linea del sitio ni del motor: solo los junta. Si se quita este
   bloque, el sitio vuelve a sus fotos de familia.
   ========================================================================== */
(function(){
  var DPR = Math.min(2, Math.max(1, window.devicePixelRatio || 1));

  /* NITIDEZ EN CELULAR (reportado el 1-sep: «se ve super borroso el frasco
     en formato celular»).

     El lienzo de la ficha se dibujaba siempre a 760 px de lado. En un
     telefono con pantalla de alta densidad esa ficha ocupa unos 1170 px
     REALES: cada pixel dibujado se pintaba sobre 1.5, y en los de 3x sobre
     2.3. No era compresion ni la foto: era resolucion.

     Se multiplica por la densidad de la pantalla, con tope de 2. El tope
     importa: un lienzo es memoria viva —lado x lado x 4 bytes— y sin freno
     un telefono modesto se queda sin ella. A 2x la ficha son 1520 px, que
     cubre de sobra cualquier telefono actual.

     Las TARJETAS del catalogo se quedan en 380 a proposito: hay cientos
     montadas a la vez y subirlas multiplicaria la memoria por cuatro. Su
     mejora pide antes soltar las que ya no se ven, que es otro trabajo. */
  /* 380 era la resolucion de una pantalla de densidad 1. En un telefono
     la misma tarjeta ocupa el doble o el triple de pixeles reales, y el
     dibujo se estiraba x2.05. Ver fusionar.py, paso 8. */
  var LADO       = Math.round(380 * DPR);
  var LADO_FICHA = Math.round(760 * DPR);
  var MAPA       = JSON.parse(document.getElementById("pm-mapa").textContent);
  var LAMINA_DE  = JSON.parse(document.getElementById("pm-lamina").textContent);
  var LAMINAS    = JSON.parse(document.getElementById("pm-laminas").textContent);
  /* El catalogo de espacio —aceites y ambientales— comparte motor con el
     perfume pero NO comparte envase: va en el atomizador ambar de 250 ml.
     Aqui vienen los indices que llevan ese frasco y el frasco mismo; se
     cambia `CAPAS.fra` justo antes de dibujarlos y se devuelve despues.
     Los difusores no entran: son aparatos, y su foto de producto es la
     correcta. */
  var ESPACIO   = JSON.parse(document.getElementById("pm-espacio").textContent);
  var GENERO    = JSON.parse(document.getElementById("pm-genero").textContent);
  var REAL      = JSON.parse(document.getElementById("pm-colorreal").textContent);
  var MAPA_ACE  = JSON.parse(document.getElementById("pm-mapaace").textContent);
  var MAPA_AMB  = JSON.parse(document.getElementById("pm-mapaamb").textContent);
  var FRASCOS_ESP = JSON.parse(document.getElementById("pm-frascos").textContent);
  var IMG_ESP={};

  var IMG={}, LISTO=false, OBS=null, MUT=null, ANIM={};

  function norm(s){
    return String(s||"").normalize("NFD").replace(/[̀-ͯ]/g,"")
      .toLowerCase().replace(/[^a-z0-9]+/g," ").trim();
  }

  /* --------------------------------------------------- las dos geometrias
     Es el esquema aprobado: en reposo las notas van DETRAS del frasco,
     apretadas en su area, y al pasar el raton salen a un anillo que le deja
     aire alrededor. El frasco se pinta siempre encima, asi que en reposo
     solo asoma lo que sobresale por los lados. */
  var DENTRO=(function(){
    var pos=[[42,38],[58,37],[40,58],[60,57],[50,30],
             [50,72],[45,46],[55,47],[43,66],[57,65]];
    var tam=[0.46,0.44,0.42,0.45,0.38,0.40,0.36,0.35,0.39,0.37];
    var out=[];
    for(var k=0;k<10;k++)
      out.push({x:pos[k][0], y:pos[k][1], ang:(k*37)%360, tam:tam[k],
                forma:(k%2===0)?"larga":"libre", sangra:false});
    return out;
  })();
  var DONA=(function(){
    var cx=50, cy=50, rx=47, ry=45, out=[];   // aire alrededor del frasco
    var tam=[1.00,0.55,0.82,0.52,0.95,0.50,0.86,0.54,0.90,0.51,0.80,0.56];
    for(var k=0;k<12;k++){
      var a=(k/12)*Math.PI*2 - Math.PI/2;
      out.push({x:+(cx+Math.cos(a)*rx).toFixed(1),
                y:+(cy+Math.sin(a)*ry).toFixed(1),
                ang:+((a*180/Math.PI)+90).toFixed(0),
                tam:tam[k], forma:(k%2===0)?"larga":"libre",
                sangra:(k%2===0)});
    }
    return out;
  })();
  function ranurasEn(t){
    var out=[];
    for(var i=0;i<DONA.length;i++){
      var a=DENTRO[i%DENTRO.length], b=DONA[i];
      out.push({x:a.x+(b.x-a.x)*t, y:a.y+(b.y-a.y)*t,
                ang:a.ang+(b.ang-a.ang)*t,
                tam:a.tam+(b.tam-a.tam)*t,
                forma:b.forma, sangra:(t>0.55)?b.sangra:false});
    }
    return out;
  }

  /* Los controles del panel del motor, puestos en su sitio ANTES de cada
     lectura. Se fijaban una sola vez al arrancar, y bastaba con que el sitio
     o el propio motor repintaran algo para que volvieran a su valor de
     fabrica: a partir de ahi `opciones()` devolvia otra cosa y las escenas
     salian con fondo, con vidrio y con otro tamano de frasco. Se notaba al
     volver por segunda vez a la rejilla, que es cuando el motor ya repinto.
     Fijarlos en cada dibujo cuesta cuatro asignaciones. */
  function fijarPanel(){
    var va=document.getElementById("va");
    if(va && va.value!=="frag") va.value="frag";
    var uf=document.getElementById("uf");
    if(uf) uf.checked=false;      // el fondo lo pinta el puente, no el motor
    var cx=document.getElementById("cx");
    if(cx) cx.checked=false;
    var va2=document.getElementById("va2");
    if(va2) va2.checked=true;     // el frasco trae su propio alfa
    var tf=document.getElementById("tf");
    if(tf && tf.value!=="74") tf.value=74;
  }

  /* ------------------------------------------------------------- dibujo */
  var TMP=null;
  function dibujarEscena(cv, idx, t){
    if(typeof RANURAS==="undefined") return;

    /* EL ENVASE VA PRIMERO, antes de `variante()`. ESPACIO trae el envase de
       cada indice: «amb» el atomizador, «ace» el frasco alto, «gen_h» la
       etiqueta azul, «gen_m» la vino; sin entrada se usa el que trae el
       motor, que es la negra del unisex.

       El orden no es un detalle. `variante()` resuelve la escena leyendo
       CAPAS.fra, asi que cambiar el frasco DESPUES no tiene ningun efecto:
       se dibujaba siempre el de fabrica. */
    var cual = ESPACIO[idx];
    var im = cual && IMG_ESP[cual];
    var esp = im && im.width;
    /* El frasco original se guarda en una variable LOCAL. Antes era global y
       compartida: dos escenas dibujandose en el mismo instante —dos tarjetas
       animandose a la vez— podian pisarsela y una devolvia el frasco de la
       otra, dejando CAPAS.fra apuntando a un envase que no era. A partir de
       ahi todo lo que se dibujara salia con el frasco equivocado. */
    var fraOriginal = null;
    if(esp){ fraOriginal = CAPAS.fra; CAPAS.fra = [{img:im}]; }

    RANURAS.length=0; ranurasEn(t).forEach(function(r){ RANURAS.push(r); });
    fijarPanel();          // antes de leer, siempre
    var o=opciones();
    var v=variante(idx, o, (document.getElementById("sem")||{}).value||"velantis");
    var g=cv.getContext("2d"), S=cv.width;
    g.clearRect(0,0,S,S);
    if(!TMP) TMP=document.createElement("canvas");
    if(TMP.width!==S){ TMP.width=TMP.height=S; }
    var gp=TMP.getContext("2d"); gp.clearRect(0,0,S,S);
    try{
      /* `separar` va SIEMPRE a cero. Dispara `apartarDelFrasco`, que expulsa
         del area del frasco justo a las piezas que queremos detras; y su
         bucle de sesenta vueltas no es continuo respecto al parametro, asi
         que interpolarlo hacia saltar las piezas en el ultimo fotograma. El
         anillo ya viene repartido por construccion. */
      dibujar(gp, S, v.semilla, {...v.o, soloProps:true, sinGrado:true,
                                 particulas:(v.o.particulas||0)*t, separar:0});
      g.drawImage(TMP,0,0);                        // las piezas
      pintarFrasco(g, S, {...v.o, sinGrado:true}); // y el frasco encima
    }catch(e){
      /* un catch mudo aqui costo una sesion entera de diagnostico: la
         escena salia en blanco y no habia forma de saber por que */
      if(!window.__pmErr){
        window.__pmErr = String(e && e.message).slice(0, 200);
      }
    }
    /* y se devuelve SIEMPRE, pase lo que pase en el dibujo */
    if(esp) CAPAS.fra = fraOriginal;
  }
  /* La lamina no se tapa con un velo: se GRADUA. `globalCompositeOperation`
     en "color" toma el tono y la saturacion del relleno y conserva la
     luminosidad de la foto, que es exactamente lo que hace un color grading
     de cine: el papel sigue teniendo su textura, sus dobleces y su luz, pero
     ahora es del color de la fragancia.

     Un degradado encima habria sido un parche de color flotando sobre una
     foto que sigue siendo beige. Esto cambia la foto. */
  function dibujarFondo(cv, lam, tinte){
    var g=cv.getContext("2d"), S=cv.width, im=IMG[lam];
    g.save();
    g.globalCompositeOperation = "source-over";
    g.clearRect(0,0,S,S);
    if(im){
      /* A GRIS PRIMERO. La lamina de acuarela es rosada, y el modo "color"
         respeta la luminosidad pero se pelea con la saturacion que ya trae:
         graduar un rosa hacia verde da un verde sucio tirando a rosa. Sin
         color propio, el tono que se pide es el tono que sale. */
      g.filter = "grayscale(1) contrast(1.06) brightness(1.03)";
      g.drawImage(im,0,0,S,S);
      g.filter = "none";
    }
    if(im && tinte){
      /* FUERZA DEL GRADO. A 0.9 el fondo quedaba pintado, no graduado: en
         las familias saturadas —ambarina, citrica, frutal— la tarjeta se
         volvia un cartel de color y el frasco perdia contra el fondo. A
         0.58 el papel conserva su propio gris y el color se lee como luz
         de ambiente, que es lo que tiene que ser: un fondo. */
      g.globalCompositeOperation = "color";
      g.globalAlpha = 0.58;
      g.fillStyle = tinte;
      g.fillRect(0,0,S,S);
      /* un punto de calor al centro, donde va el frasco, para que el grado
         no aplane la foto en un solo tono */
      g.globalCompositeOperation = "soft-light";
      g.globalAlpha = 0.26;
      var rad = g.createRadialGradient(S*0.5,S*0.44,0, S*0.5,S*0.44,S*0.62);
      rad.addColorStop(0, tinte);
      rad.addColorStop(1, "rgba(0,0,0,0)");
      g.fillStyle = rad;
      g.fillRect(0,0,S,S);
    }
    g.restore();
  }

  function animar(caja, idx, hacia){
    var esc=caja.querySelector("canvas.escena"); if(!esc) return;
    var a=ANIM[idx+"|"+(caja.dataset.pmId||"")]||(ANIM[idx+"|"+(caja.dataset.pmId||"")]={t:0,raf:0});
    if(a.raf) cancelAnimationFrame(a.raf);
    var desde=a.t, ini=null, dur=(hacia>a.t)?560:520;
    a.raf=requestAnimationFrame(function paso(ahora){
      if(ini===null) ini=ahora;
      var k=Math.min(1,(ahora-ini)/dur);
      /* La misma curva de ida y de vuelta, invertida. Al salir, exponencial:
         arranca de golpe y frena, que es como se ve una explosion. Al volver,
         del reves, para que las piezas se recojan en vez de salir disparadas
         hacia dentro. Con `out` en los dos sentidos el regreso parecia otra
         explosion. */
      var e=(hacia>desde) ? (k===1?1:1-Math.pow(2,-9*k))
                          : (k===0?0:Math.pow(2,-9*(1-k)));
      a.t=desde+(hacia-desde)*e;
      dibujarEscena(esc, idx, a.t);
      if(k<1) a.raf=requestAnimationFrame(paso); else a.raf=0;
    });
  }

  /* De que fragancia es este hueco. En el catalogo el nombre esta en el
     `data-name` de la tarjeta; en la ficha, en #ppName. */
  function nombreDe(el){
    /* En aceites y ambientales el nombre limpio esta en `data-lhs` —el
       `data-name` de la tarjeta trae pegado el formato: «Vidanta · Aceite
       100 ml»—. En su ficha, en #lhsName. */
    var lhs=el.closest("[data-lhs]");
    if(lhs && lhs.dataset.lhs) return lhs.dataset.lhs.replace(/^AMB:/,"");
    if(el.id==="lhsImg"){
      var ln=document.getElementById("lhsName");
      if(ln) return ln.textContent;
    }
    var host=el.closest("[data-name]");
    if(host && host.dataset.name) return host.dataset.name;
    if(el.id==="ppImg"){
      /* 3-sep: el titulo visible ya dice «Inspirado en Fico Di Amalfi, de
         Acqua di Parma»; el nombre crudo del producto vive en data-nombre del
         h1 y en data-name de #ppInfo. Leer el texto del h1 dejaba al motor
         sin formula y la ficha caia a la foto fija por familia. */
      var info=document.getElementById("ppInfo");
      if(info && info.dataset.name) return info.dataset.name;
      var n=document.getElementById("ppName");
      if(n) return n.dataset.nombre || n.textContent;
    }
    var art=el.closest("article,.card,.cat-card");
    if(art){
      var h=art.querySelector("h3,h2,.cat-card h3");
      if(h) return h.textContent;
    }
    return "";
  }

  /* ------------------------------------------------- la luz de la escena
     El promedio de los colores de las notas, en RGB y pesado por presencia
     igual que lo hace el motor: `(p/100)^3`. El cubo importa —sin el, una
     nota de fondo al 46 % tira tanto como la cabeza al 100 % y todo acaba
     en el mismo pardo.

     Despues se aclara y se satura. Un promedio crudo de ocho notas cae casi
     siempre en un cafe apagado: es fiel a la suma y no se parece a ninguna
     de las notas. Lo que se busca es la luz que echaria esa fragancia, no
     su promedio contable. */
  /* DE DONDE SALE EL TONO. Dos criterios, y no dan lo mismo:

       "notas"    el promedio de los colores de SUS notas. Cada fragancia
                  distinta de su vecina, pero dentro de una familia los
                  tonos se parecen y a veces se cruzan.
       "familia"  el tono que el motor ya tiene asignado a las 12 familias
                  —citrica 52, marina 203, floral 342...—. Mas legible como
                  sistema: todas las marinas azules, todas las florales
                  rosas; a cambio, doce colores para 579 fragancias.

     Se cambia aqui. El resto del puente no se entera. */
  var CRITERIO = "familia";

  /* EL FONDO POR FAMILIA.

     No se usa el `tono` de COLOR_FAMILIA tal cual. Ese juego esta hecho para
     tenir las notas dentro de la escena, y medido sobre el catalogo deja
     SIETE familias dentro de 36 grados —frutal 6, especiada 16, cuero 20,
     amaderada 26, gourmand 30, ambarina 40, almizclada 42—: como fondo se
     verian todas del mismo naranja.

     Aqui se separan tambien por saturacion y luz, que es como se distingue
     una madera de un ambar en la vida real: no por el tono, por la
     profundidad. El cuero es oscuro y apagado, el ambar es encendido, el
     almizcle es palido y casi neutro. Mismo tono, lecturas distintas. */
  var FONDO_FAMILIA = {
    citrica:    "hsl(52,62%,66%)",   // amarillo abierto
    verde:      "hsl(104,42%,60%)",  // hoja
    aromatica:  "hsl(78,38%,60%)",   // herbal
    marina:     "hsl(203,52%,64%)",  // azul
    frutal:     "hsl(352,58%,66%)",  // rojo de fruta
    floral:     "hsl(330,44%,71%)",  // rosa claro
    gourmand:   "hsl(28,60%,62%)",   // caramelo
    especiada:  "hsl(10,52%,56%)",   // rojo de especia
    amaderada:  "hsl(30,30%,50%)",   // madera, apagada y media
    ambarina:   "hsl(40,68%,60%)",   // ambar encendido
    cuero:      "hsl(16,40%,44%)",   // oscuro
    almizclada: "hsl(44,16%,69%)"    // palido, casi neutro
  };

  function tonoDeFamilia(frag){
    if(typeof familiaDe !== "function") return null;
    return FONDO_FAMILIA[familiaDe(frag)] || null;
  }

  /* EL GENERO CORRIGE EL FONDO.

     La familia sale de votar los acordes, y muchos perfumes de caballero
     votan floral —jazmin, azahar y rosa son estructura de fondo en media
     perfumeria masculina— asi que al pasar el raton por la coleccion de
     hombre se encendian rosas y violetas brillantes.

     No se cambia la familia: eso seria mentir sobre la formula. Se cambia
     como se ILUMINA: en caballero el rosa y el violeta se llevan a su
     equivalente calido y todo baja de luz, que es la diferencia real entre
     una version masculina y una femenina del mismo acorde —profundidad, no
     otro ingrediente—. En dama sube la luz. Unisex se queda como esta. */
  function porGenero(hsl, gen){
    if(!hsl || gen === "u") return hsl;
    var m = /hsl\((-?[\d.]+),\s*([\d.]+)%,\s*([\d.]+)%\)/.exec(hsl);
    if(!m) return hsl;
    var h = (parseFloat(m[1]) + 360) % 360,
        s = parseFloat(m[2]), l = parseFloat(m[3]);
    if(gen === "h"){
      /* La banda rosa-violeta —285 a 360— se lleva a AZUL CLARO. El ambar
         que habia antes resolvia el rosa pero dejaba la coleccion de
         caballero en un solo bloque naranja, porque las familias calidas ya
         ocupan casi todo lo demas. El azul separa de verdad y es el otro
         extremo del circulo, asi que el contraste entre una tarjeta y su
         vecina se lee de un vistazo. */
      if(h >= 285 || h <= 5){
        var d = h >= 285 ? (h - 285) : (h + 75);   // 0..80 dentro de la banda
        h = 196 + d * 0.20;                         // 196..212, azul claro
        s = Math.min(Math.max(s, 34), 46);
        l = Math.min(72, Math.max(l, 62));          // claro, como se pidio
        return "hsl(" + h.toFixed(0) + "," + s.toFixed(0) + "%,"
                      + l.toFixed(0) + "%)";
      }
      s = s * 0.86;
      l = Math.max(38, l - 11);      // mas hondo
    }else{
      l = Math.min(78, l + 4);
      s = Math.min(72, s * 1.04);
    }
    return "hsl(" + h.toFixed(0) + "," + s.toFixed(0) + "%," + l.toFixed(0) + "%)";
  }

  /* CUANTO COLOR: lo dice la fotografia, no la paleta.

     `REAL` trae, por ranura, el color promedio MEDIDO sobre las 76 fotos de
     ingrediente del motor: pixel a pixel, pesando por alfa. Un ambar da 74 %
     de saturacion y un acuatico da 7 %, porque asi son las fotos.

     Para una fragancia se promedian esos colores reales —pesados por
     presencia, `(p/100)^3`— y se toma la saturacion del promedio. Eso hace
     dos cosas de golpe:

       · una fragancia de citricos y ambar sale encendida; una de almizcle
         y acuatico sale casi neutra. Ya no es un techo plano para todas.
       · si las notas se pelean en color, el promedio se apaga solo. Una
         formula coherente da fondo vivo; una dispersa, fondo sobrio. Eso
         no hubo que programarlo: sale de promediar.

     El TONO sigue viniendo de la familia y del genero. Esto solo decide la
     intensidad. */
  var SAT_MIN = 8, SAT_MAX = 46;

  function satReal(acordes){
    if(!acordes || !acordes.length) return null;
    var r=0, g=0, b=0, peso=0;
    for(var i=0;i<acordes.length;i++){
      var c = REAL[acordes[i].s];
      if(!c) continue;
      var w = Math.pow((acordes[i].p==null?100:acordes[i].p)/100, 3);
      /* de vuelta a RGB para promediar donde el promedio significa algo */
      var hh=c.h/360, ll=c.l/100, ss=c.s/100;
      var q = ll < 0.5 ? ll*(1+ss) : ll+ss-ll*ss, pp = 2*ll-q;
      function ca(tt){ tt=(tt+1)%1;
        return tt<1/6 ? pp+(q-pp)*6*tt : tt<1/2 ? q
             : tt<2/3 ? pp+(q-pp)*(2/3-tt)*6 : pp; }
      r += ca(hh+1/3)*w; g += ca(hh)*w; b += ca(hh-1/3)*w; peso += w;
    }
    if(!peso) return null;
    r/=peso; g/=peso; b/=peso;
    var mx=Math.max(r,g,b), mn=Math.min(r,g,b), l=(mx+mn)/2, d=mx-mn;
    var s = d===0 ? 0 : d/(1-Math.abs(2*l-1));
    return Math.max(SAT_MIN, Math.min(SAT_MAX, s*100*1.15));
  }

  function calmar(hsl, acordes){
    if(!hsl) return hsl;
    var m = /hsl\((-?[\d.]+),\s*([\d.]+)%,\s*([\d.]+)%\)/.exec(hsl);
    if(!m) return hsl;
    var medida = satReal(acordes);
    var s = medida != null ? medida
                           : Math.min(SAT_MAX, parseFloat(m[2]) * 0.74);
    return "hsl(" + m[1] + "," + s.toFixed(0) + "%," + m[3] + "%)";
  }

  function tinteDe(frag, idx){
    if(!frag) return null;
    var c = (CRITERIO === "familia") ? (tonoDeFamilia(frag) || luzDe(frag.a))
                                     : (luzDe(frag.a) || tonoDeFamilia(frag));
    return calmar(porGenero(c, GENERO[idx] || "u"), frag.a);
  }

  function luzDe(acordes){
    if(!acordes || !acordes.length) return null;
    var r=0, g=0, b=0, peso=0;
    for(var i=0;i<acordes.length;i++){
      var a=acordes[i], c=a.c || a.color;
      if(!c) continue;
      var h=String(c).replace("#","");
      if(h.length===3) h=h[0]+h[0]+h[1]+h[1]+h[2]+h[2];
      var n=parseInt(h,16); if(isNaN(n)) continue;
      var w=Math.pow((a.p==null?100:a.p)/100, 3);
      r+=((n>>16)&255)*w; g+=((n>>8)&255)*w; b+=(n&255)*w; peso+=w;
    }
    if(!peso) return null;
    r/=peso; g/=peso; b/=peso;

    /* a HSL para poder subir el color sin cambiar el tono */
    var mx=Math.max(r,g,b)/255, mn=Math.min(r,g,b)/255, l=(mx+mn)/2, d=mx-mn;
    var s=d===0?0:d/(1-Math.abs(2*l-1));
    var hh=0;
    if(d!==0){
      var R=r/255,G=g/255,B=b/255;
      hh = mx===R ? ((G-B)/d + (G<B?6:0)) : mx===G ? ((B-R)/d+2) : ((R-G)/d+4);
      hh*=60;
    }
    /* EXPANSION DE GAMA, la misma tecnica que usa el motor para graduar.
       Medido sobre las 409 del sitio: el promedio crudo mete 366 en la
       misma banda naranja —citricos, maderas, vainillas y ambares son todos
       calidos, asi que ser fiel al ingrediente ES ser monotono— y todas las
       tarjetas se encendian del mismo color, que era justo lo contrario de
       lo que se busca.

       Esto no inventa el orden, lo estira: lo que era mas rojo sigue siendo
       mas rojo, solo que ahora se nota. Con k=2.4 el catalogo ocupa 10 de
       las 12 franjas de tono en vez de 3. */
    var CENTRO = 34, K = 2.4;
    var dd = hh - CENTRO;
    while(dd >  180) dd -= 360;
    while(dd < -180) dd += 360;
    hh = (CENTRO + dd * K + 720) % 360;

    s = Math.min(0.72, s*1.55 + 0.14);   // que se distinga de sus vecinas
    l = Math.min(0.74, Math.max(0.52, l*0.45 + 0.42));  // luz, no pigmento
    return "hsl(" + hh.toFixed(0) + "," + (s*100).toFixed(0) + "%,"
                  + (l*100).toFixed(0) + "%)";
  }

  /* Los alias de los Best Sellers se retiraron junto con `.card .foto`:
     solo servian para que esas cuatro tarjetas escritas a mano encontraran
     su formula, y ahora conservan su fotografia original. El problema de
     fondo sigue ahi y es del dev: esas cuatro no salen del catalogo, asi
     que no tienen SKU ni precio y no se pueden vender desde la portada. */
  var contador=0;
  function montar(el){
    if(!LISTO || el.dataset.pmHecho) return;
    var nom=norm(nombreDe(el));
    /* De que catalogo es ESTE hueco. El nombre no basta: «Vidanta» existe
       como perfume, como aceite y como ambiental, y cada uno va en su
       envase. Se decide por donde esta montado:

         .oil-img ................. tarjeta de aceite
         .amb-img / data-img=n-amb  tarjeta de ambiental
         #lhsImg .................. la ficha; lo dice su enlace de volver
         el resto ................. catalogo de perfume                    */
    var mapa = MAPA;
    var tarjeta = el.closest("[data-img]");
    var marca = tarjeta ? (tarjeta.getAttribute("data-img") || "") : "";
    var lhs = el.closest("[data-lhs]");
    var ref = lhs ? (lhs.getAttribute("data-lhs") || "") : "";

    /* CUIDADO CON EL ORDEN. El dev reutilizo la rejilla de aceites para los
       ambientales, asi que las DOS tarjetas llevan la clase `oil-img`:

           <div class="oil-img oil-ph">        aceite
           <div class="oil-img amb-card-img">  ambiental

       Preguntar por `oil-img` primero mandaba los sesenta ambientales al
       mapa de aceites y salian con el frasco alto transparente. Lo
       especifico va antes que lo general: la marca de ambiental —su clase
       propia, su `data-img` o el prefijo AMB: de su ficha— se resuelve
       primero, y solo si no la lleva se trata como aceite. */
    if(el.classList.contains("amb-card-img") ||
       el.classList.contains("amb-img") ||
       marca === "amb-img" || /^n-amb/.test(marca) ||
       /^AMB:/.test(ref)){
      mapa = MAPA_AMB;
    }else if(el.classList.contains("oil-img")){
      mapa = MAPA_ACE;
    }else if(el.id === "lhsImg"){
      var atras = document.getElementById("lhsBack");
      var h = atras ? (atras.getAttribute("href") || "") : "";
      mapa = /aceites/.test(h) ? MAPA_ACE : MAPA_AMB;
    }
    var idx = mapa[nom];
    if(idx == null && mapa !== MAPA) idx = MAPA[nom];   // ultimo recurso
    if(idx==null) return;                    // sin formula: se queda su foto
    el.dataset.pmHecho="1";
    /* para que nombre se dibujo: si el hueco se reutiliza con otro
       producto, hay que volver a dibujarlo. Ver el barrido. */
    el.dataset.pmNom=nom;
    el.dataset.pmId=(++contador);
    el.classList.add("con-motor");
    var S=(el.id==="ppImg"||el.id==="lhsImg")?LADO_FICHA:LADO;
    el.insertAdjacentHTML("beforeend",
      '<canvas class="fondo"  width="'+S+'" height="'+S+'"></canvas>'+
      '<canvas class="escena" width="'+S+'" height="'+S+'"></canvas>');
    var tinte = tinteDe((typeof FRAGANCIAS !== "undefined")
                        ? FRAGANCIAS[idx] : null, idx);
    dibujarFondo(el.querySelector("canvas.fondo"), LAMINA_DE[nom]||"acuarela", tinte);

    /* Dos huecos se ven ABIERTOS desde el principio, sin pasar el raton: la
       imagen de la ficha —que es la pantalla donde se decide— y las tarjetas
       de «fragancias similares». Estas ultimas, ademas, porque en reposo las
       notas van detras del frasco y seis seguidas en fila se leian como seis
       fotos iguales. Abiertas, cada una ensena su propia formula. */
    var abierta = (el.id==="ppImg") || (el.id==="lhsImg")
            || el.classList.contains("pp-simimg");
    var disp=el.closest(".cat-card,article,.card")||el;
    if(abierta){
      ANIM[idx+"|"+el.dataset.pmId]={t:1,raf:0};
      dibujarEscena(el.querySelector("canvas.escena"), idx, 1);
    }else{
      dibujarEscena(el.querySelector("canvas.escena"), idx, 0);
      disp.addEventListener("mouseenter",function(){ animar(el,idx,1); });
      disp.addEventListener("mouseleave",function(){ animar(el,idx,0); });
    }
  }

  /* DONDE SI Y DONDE NO.

     El motor entra en el catalogo y en la ficha, que es donde la persona
     compara y decide y donde las ocho fotos de familia repetidas hacian
     dano de verdad.

     NO entra en los heros ni en las secciones fijas de la portada
     —Temporada, Novedades 2026, Best Sellers—, que usan `.card .foto`. Ahi
     va la fotografia original: son piezas compuestas, con su encuadre y su
     luz, y una escena generada al lado se ve peor, no mejor. */
  var SEL=".cat-img, .pp-img, .pp-simimg, "+
          ".oil-img, .amb-img, #lhsImg";

  /* SOLTAR LO QUE YA NADIE VE.

     Cada lienzo es memoria viva: lado x lado x 4 bytes. Al subir el lado de
     380 a 760 esa memoria se cuadruplica, y medido en el sitio llegaban a
     estar montados 26 lienzos a la vez (14.3 MB) aunque solo CUATRO cupieran
     en pantalla. A 760 eso serian 57 MB, demasiado para un telefono modesto:
     por eso el 1-sep las tarjetas se dejaron en 380 y se anoto que su mejora
     pedia antes soltar las que se van. Esto es ese trabajo.

     Se monta a 1500 px de distancia (rootMargin del observador) y se suelta
     a partir de 2600. La diferencia entre los dos numeros es a proposito:
     sin esa holgura, una tarjeta parada en el borde se montaria y soltaria
     sin parar mientras el dedo tiembla.

     Soltar es quitarle los lienzos y la clase. No hace falta nada mas: el
     barrido ya sabe que un hueco con `pmHecho` pero sin lienzo hay que
     volver a montarlo —es la reparacion del «se ve bien la primera vez y a
     la segunda se rompe»—, asi que al volver se dibuja solo. */
  var LEJOS = 2600;
  function soltarLejanos(){
    var v = document.querySelectorAll(".cat-img[data-pm-hecho]");
    for(var i = 0; i < v.length; i++){
      var el = v[i];
      if(el.id === "ppImg" || el.id === "lhsImg") continue;   // la ficha se queda
      if(!el.querySelector("canvas")) continue;
      var r = el.getBoundingClientRect();
      var fuera = (r.top > window.innerHeight + LEJOS) || (r.bottom < -LEJOS);
      if(!fuera) continue;
      var cs = el.querySelectorAll("canvas");
      for(var j = 0; j < cs.length; j++){
        cs[j].width = cs[j].height = 0;    // libera el respaldo del lienzo
        cs[j].remove();
      }
      el.classList.remove("con-motor");
      if(el.dataset.pmId) delete ANIM[el.dataset.pmId];
    }
  }

  function barrer(){
    if(!LISTO) return;
    soltarLejanos();
    var v=document.querySelectorAll(SEL);
    for(var i=0;i<v.length;i++){
      var el=v[i];

      /* EL HUECO QUE PIERDE SU CLASE.

         Al repintar la ficha el sitio reescribe `className` entero, y con
         eso borra `con-motor` —pero `data-pmHecho` sobrevive, porque es un
         atributo aparte—. El resultado: los canvas siguen ahi, ya sin
         `position:relative` que los sujete, asi que se salen del hueco y
         tapan media pagina; y por debajo reaparece la foto de familia.

         Era el «se ve bien la primera vez y a la segunda se rompe». Aqui
         se detecta y se repara: si el lienzo sigue puesto basta devolver
         la clase; si tambien se lo llevaron, se monta de nuevo. */
      if(el.dataset.pmHecho){

        /* EL HUECO QUE CAMBIA DE PRODUCTO.

           `#ppImg` es UN solo elemento que la ficha reutiliza. Al abrir el
           segundo perfume el sitio le reescribe la clase, pero `pmHecho`
           sobrevive y el lienzo del primero sigue puesto: el motor lo daba
           por hecho y no volvia a dibujar. Se veian el nombre y las notas
           del segundo con la escena del primero.

           Se compara con el nombre para el que se dibujo. Si cambio, se
           tiran los lienzos y se monta de nuevo. En las tarjetas del
           catalogo el nombre nunca cambia, asi que esto no las toca. */
        if(el.dataset.pmNom && el.dataset.pmNom !== norm(nombreDe(el))){
          delete el.dataset.pmHecho;
          delete el.dataset.pmNom;
          var viejos=el.querySelectorAll("canvas");
          for(var q=0;q<viejos.length;q++) viejos[q].parentNode.removeChild(viejos[q]);
          el.classList.remove("con-motor");
          if(OBS) OBS.observe(el); else montar(el);
          continue;
        }

        if(!el.classList.contains("con-motor")){
          if(el.querySelector("canvas.escena")){
            el.classList.add("con-motor");
          }else{
            delete el.dataset.pmHecho;
            if(OBS) OBS.observe(el); else montar(el);
          }
        }
        continue;
      }
      if(OBS) OBS.observe(el); else montar(el);
    }
  }

  function arrancarObservadores(){
    if("IntersectionObserver" in window){
      OBS=new IntersectionObserver(function(es){
        es.forEach(function(e){
          if(e.isIntersecting){ montar(e.target); OBS.unobserve(e.target); }
        });
      },{rootMargin:"1500px"});
    }
    /* El sitio repinta al filtrar, al buscar y al cambiar de ruta: hay que
       volver a barrer cada vez que cambia el DOM. */
    MUT=new MutationObserver(function(){
      clearTimeout(MUT._t); MUT._t=setTimeout(barrer,80);
    });
    MUT.observe(document.body,{childList:true,subtree:true});
    barrer();

    /* Y se insiste. El observador de interseccion depende de que el
       navegador calcule posiciones, y en una pagina de 16 MB que sigue
       montando cosas eso llega tarde o no llega: el resultado era una
       rejilla con las fotos de familia repetidas, como si el puente no
       existiera. Un barrido cada segundo y medio durante el primer par de
       minutos cuesta nada y quita el problema de raiz. */
    var repasos = 0;
    var reloj = setInterval(function(){
      barrer();
      if(++repasos > 80) clearInterval(reloj);   // dos minutos
    }, 1500);
    window.addEventListener("scroll", function(){
      clearTimeout(barrer._s); barrer._s = setTimeout(barrer, 90);
    }, {passive:true});
  }

  function listoElMotor(){
    return typeof dibujar==="function" && typeof opciones==="function"
        && typeof variante==="function" && typeof CAPAS!=="undefined"
        && CAPAS.tex && CAPAS.tex.length;
  }
  /* La espera. 400 intentos a 120 ms son 48 segundos, y con la pagina en
     16 MB el motor tarda mas que eso en tener su kit listo: el puente se
     rendia justo antes y la pagina se quedaba sin una sola escena. Diez
     minutos de margen no cuestan nada —son un setTimeout que se apaga solo
     en cuanto el kit aparece— y cubren un equipo lento o una tableta. */
  var n=0;
  (function esperar(){
    if(!listoElMotor()){
      if(++n>5000){ console.warn("[puente] el motor no cargo su kit"); return; }
      return setTimeout(esperar,120);
    }
    fijarPanel();
    var va=document.getElementById("va");
    if(va) va.dispatchEvent(new Event("change"));
    CAPAS.fon=[];

    var falta=0;
    Object.keys(FRASCOS_ESP).forEach(function(k){
      falta++;
      var im=new Image();
      im.onload=im.onerror=function(){ IMG_ESP[k]=im; if(--falta===0) listo(); };
      im.src=FRASCOS_ESP[k];
    });
    Object.keys(LAMINAS).forEach(function(k){
      falta++;
      var im=new Image();
      im.onload=im.onerror=function(){ IMG[k]=im; if(--falta===0) listo(); };
      im.src=LAMINAS[k];
    });
    if(!falta) listo();

    function listo(){
      if(LISTO) return;
      LISTO=true;
      arrancarObservadores();
      /* un reporte que se puede leer desde la consola: `__puente()` */
      window.__puente = function(forzar){
        var v = document.querySelectorAll(SEL), sin = [], con = 0, err = null;
        for(var i=0;i<v.length;i++){
          if(v[i].dataset.pmHecho){ con++; continue; }
          if(sin.length < 5){
            var nm = nombreDe(v[i]);
            sin.push({clase:v[i].className.slice(0,26), nombre:nm,
                      norm:norm(nm), enMapa:MAPA[norm(nm)] != null,
                      visible:v[i].getBoundingClientRect().top});
          }
        }
        if(forzar){
          try{ montar(v[forzar-1] || v[0]); }
          catch(e){ err = e.message; }
        }
        var fr = {};
        Object.keys(IMG_ESP).forEach(function(k){
          fr[k] = IMG_ESP[k] ? (IMG_ESP[k].width + "x" + IMG_ESP[k].height +
                                (IMG_ESP[k].complete ? " ok" : " incompleta"))
                             : "null"; });
        return {listo:LISTO, huecos:v.length, montados:con, intentos:n,
                hayObservador:!!OBS, enMapa:Object.keys(MAPA).length,
                errorAlForzar:err, frascos:fr,
                declarados:Object.keys(FRASCOS_ESP),
                error:window.__pmErr || null, muestra:sin};
      };
      console.log("[puente] motor montado ·",
                  Object.keys(MAPA).length,"fragancias con escena");
    }
  })();
})();
